<template>
	<div>
		<SectionCard title="Esportazioni extra-UE" icon="mdi-airplane-takeoff" subtitle="non imponibili art. 8 · serve la prova dell’uscita della merce" no-padding data-tour="exports">
			<v-simple-table dense>
				<thead>
					<tr>
						<th>Paese</th>
						<th class="text-right">Imponibile</th>
						<th class="text-right">IVA italiana addebitata</th>
						<th class="text-right">Ordini</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="e in report.exports" :key="`${e.country}:${e.territory}`">
						<td>
							<span class="fo-code">{{ e.country }}</span> {{ countryName(e.country) }}
							<span v-if="e.territory" class="fo-muted"> · {{ e.territory }} (fuori dal territorio IVA UE)</span>
						</td>
						<td class="text-right fo-strong">{{ formatEurCents(e.net) }}</td>
						<td class="text-right" :class="{ 'orange--text text--darken-2': e.itVatCharged > 0 }">{{ formatEurCents(e.itVatCharged) }}</td>
						<td class="text-right">{{ formatNumber(e.orders) }}</td>
					</tr>
					<tr v-if="!report.exports.length">
						<td colspan="4" class="text-center grey--text py-4">Nessuna spedizione fuori dall’Unione nel periodo.</td>
					</tr>
				</tbody>
			</v-simple-table>
		</SectionCard>

		<SectionCard title="Vendite estere sui marketplace" icon="mdi-storefront-outline" subtitle="imposte locali incassate e versate dal marketplace" no-padding class="mt-2" data-tour="marketplace">
			<v-simple-table dense>
				<thead>
					<tr>
						<th>Canale</th>
						<th>Paese</th>
						<th class="text-right">Venduto (lordo)</th>
						<th class="text-right">Ordini</th>
						<th class="text-right">Imposta trattenuta</th>
						<th>Regola</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="m in report.marketplace" :key="`${m.platform}:${m.country}`">
						<td>{{ sourceName(m.platform) }}</td>
						<td>
							<span class="fo-code">{{ m.country }}</span> {{ countryName(m.country) }}
						</td>
						<td class="text-right">{{ formatEurCents(m.gross) }}</td>
						<td class="text-right">{{ formatNumber(m.orders) }}</td>
						<td class="text-right">
							<span v-if="m.taxOrders">{{ formatEurCents(m.tax) }}</span>
							<span v-else class="fo-muted">—</span>
							<div v-if="m.likely" class="fo-muted">{{ m.likely }} ordini senza dato</div>
						</td>
						<td class="fo-muted">{{ m.collect ? m.collect.note : m.eu ? 'Vendita UE: l’IVA resta a carico tuo (OSS o italiana)' : 'Nessuna imposta locale versata dal marketplace' }}</td>
					</tr>
					<tr v-if="!report.marketplace.length">
						<td colspan="6" class="text-center grey--text py-4">Nessuna vendita estera su Amazon o eBay nel periodo.</td>
					</tr>
				</tbody>
			</v-simple-table>
			<div class="fo-muted pa-3">
				L’imposta trattenuta arriva dagli ordini importati (eBay e Amazon). Per gli ordini importati prima di questa versione il dato può mancare: su eBay si recupera dallo storico, su Amazon solo per
				i nuovi ordini.
			</div>
		</SectionCard>
	</div>
</template>

<script>
import SectionCard from '@/components/core/SectionCard.vue';
import { formatEurCents, formatNumber, sourceName } from '@/components/finance/format';
import { countryName } from './labels';

export default {
	name: 'ForeignExports',
	components: { SectionCard },
	props: {
		report: { type: Object, required: true },
	},
	methods: { formatEurCents, formatNumber, sourceName, countryName },
};
</script>

<style scoped>
.fo-code {
	font-family: monospace;
	font-size: 12px;
	color: #5f6b7a;
}
.fo-strong {
	font-weight: 600;
}
.fo-muted {
	font-size: 12px;
	color: #5f6b7a;
}
</style>
